module.exports = __webpack_public_path__ + "img/roadmap-cell-background.566daedd.svg";